import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Heading, HStack, Link, Stack, Tab, TabList, TabPanels, Tabs, Text, VStack } from '@chakra-ui/react';
import { useHistory } from "react-router-dom";
import * as Yup from 'yup';
import { GoogleMap, LoadScript, Marker, StandaloneSearchBox } from '@react-google-maps/api';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { FiTrash2, FiEdit3 } from 'react-icons/fi';
import { MdFace, MdOutlineArrowBack } from 'react-icons/md';
import { v4 as uuid } from 'uuid';

import api from '../../services/api';
import { useToast } from '../../hooks/toast';
import Input from '../../components/Inputs/Input';
import { AppError } from '../../utils/AppError';
import getValidationErrors from '../../utils/getValidationErrors';
import InputSelect from '../../components/Inputs/Selects/InputSelect';
import InputTextArea from '../../components/Inputs/inputTextArea';
import EndEditMap from '../../components/ComponentsPerfil/EndEditMap';
import Loading from '../../components/Loading';
import ModalAcesso from '../../components/ComponentsSignup/ModalAcesso';
import ModalPerfilNumero from '../../components/ComponentsPerfil/ModalPerfilNumero';
import ModalPerfilEndConfirm from '../../components/ComponentsPerfil/ModalPerfilEndConfirm';

import { Container, Content, FormView, GestaoAcessoForm, GestaoAcessos, GestaoAcessosContent, MapView, TabEndereco, TabLoja, TabsView } from './styles';

type LojaDATA = {
	id: string;
	cnpj: string;
	insc_estadual: string;
	fantazia: string;
	nome: string;
	categoria: string;
	descricao: string;
	ped_min: number;
	url_avatar: string;
	url_page: string;
	fone: string;
	endereco: EnderecoDATA;
	acessos?: AcessoDATA[];
}
type EnderecoDATA = {
	cep: string;
	uf: string;
	cid: string;
	cidcod: string;
	bai: string;
	endereco: string;
	num: string;
	comp: string;
	formatted_address: string;
	location: {
		lat: number;
		lng: number;
	};
}
type AcessoDATA = {
	id: string;
	nome: string;
	email: string;
	password: string;
	role: string;
	status: string;
}

// 30.487.846/0001-69

const SignUp: React.FC = () => {
	const formRef = useRef<FormHandles>(null);
	const formMapRef = useRef<FormHandles>(null);
	const searchBoxRef = useRef<any>(null);

	const history = useHistory();

	const { addToast } = useToast();
	
	const [loading, setLoading] = useState(true);
	const [loadingContent, setLoadingContent] = useState(false);
	const [tabIndex, setTabIndex] = useState(0);
	const [tabEnd, setTabEnd] = useState(true);
	const [tabAcesso, setTabAcesso] = useState(true);

	// Tab LOJA
	const [loja, setLoja] = useState<LojaDATA>({} as LojaDATA);
	const [categorias, setCategorias] = useState<any[]>([]);

	// Tab ENDEREÇO
	const [endereco, setEndereco] = useState<EnderecoDATA>({} as EnderecoDATA);
	const [loadingMap, setLoadingMap] = useState(false);
	const [ampliar, setAmpliar] = useState(false);
	const [center, setCenter] = useState<any>({
		lat: -20.53690225701261,
		lng: -47.4013434553716,
	});
	const [map, setMap] = useState<google.maps.Map | null>(null);
	const [searchBox, setSearchBox] = useState<google.maps.places.SearchBox>();
	const [markers, setMarkers] = useState<any[]>([]);
	const [zoom, setZoom] = useState(13);
	const [mapHeight, setMapHeight] = useState('39.2vh');
	const [modalEndNumeroVisible, setModalEndNumeroVisible] = useState(
		false,
	);
	const [
		modalEndConfirmVisible,
		setModalEndConfirmVisible,
	] = useState(false);
	const [placesAux, setPlacesAux] = useState<any>();

	const [libraries, setLibraries] = useState<any[]>([]);

	// Tab GESTÃO DE ACESSOS
	const [acesso, setAcesso] = useState<AcessoDATA>({} as AcessoDATA);
	const [modalAcessoVisible, setModalAcessoVisible] = useState(false);

	async function fetchPerfil() {
		try {
			const { data } = await api.get('/portal/perfil');
			setCategorias([ ...data ]);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível buscar o perfil.';

			addToast({
				type: 'error',
				title: 'Buscar Perfil!',
				description: msg,
			});
		}
		finally {
			setLoading(false);
			setLoadingMap(true);
		}
	};

	// quando trocar a empresa busca os acessos
	useEffect(() => {
		// setLoading(true);
		setLibraries(['places']);
		fetchPerfil();
		handleMoeda('ped_min');
		// handleAcessos();
	}, []);

	// Tab LOJA
	async function fetchCnpj(field: string) {
		try {
			// 13.266.571.0001-14
			// 13266571000114
			if (!field)
				return;

			const auxCnpj = field.replace(/\D/g, '');
			delete api.defaults.headers.common['Authorization'];
			delete api.defaults.headers.common['company'];
			const { data } = await api.get(`https://brasilapi.com.br/api/cnpj/v1/${auxCnpj}`);

			const {
				razao_social,
				ddd_telefone_1,
				cep,
				uf,
				municipio,
				bairro,
				logradouro,
				numero
			} = data;
			
			formRef.current?.setFieldValue('nome', razao_social);
			formRef.current?.setFieldValue('fone', ddd_telefone_1);
			handleMaskPhone(formRef.current?.getFieldValue('fone'));
			document.getElementById('insc_estadual')?.focus();

			const auxEndereco = `${logradouro}, ${numero} ${bairro}, ${municipio} - ${uf}, ${cep}`;

			formMapRef.current?.setFieldValue('endereco', auxEndereco);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível buscar dados de cnpj da loja.';

			addToast({
				type: 'error',
				title: 'Cnpj da Loja',
				description: msg,
			});
		}
	};
	function handleMaskCnpj(value: string) {
		let res = value;
		res = res.replace(/\D+/g, '');
		res = res.replace(/^(\d{2})(\d)/, "$1.$2");
		res = res.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
		res = res.replace(/\.(\d{3})(\d)/, ".$1/$2");
		res = res.replace(/(\d{4})(\d)/, "$1-$2");
		formRef.current?.setFieldValue('cnpj', res);
		// setValue('doc', res);
	};

	function handleMaskPhone(event: string) {
		let res = event;
		res = res.replace(/\D/g, '');
		res = res.replace(/^(\d{2})(\d)/g, '($1) $2');
		res = res.replace(/(\d)(\d{4})$/, '$1-$2');
		formRef.current?.setFieldValue('fone', res);
	};

	async function handleMoeda(field: string) {
		let moedastr = formRef.current?.getFieldValue(`${field}`);

		if (moedastr === '' || moedastr === null || moedastr === undefined) {
			formRef.current?.setFieldValue(`${field}`, `R$ 0,00`);
			return;
		}

		moedastr = moedastr.replace(/\D/g, '');

		if (moedastr) {
			const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));

			let tmp = `${moeda}`;
			tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
			if (tmp.length > 6)
				tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

			formRef.current?.setFieldValue(`${field}`, `R$ ${tmp}`);
		} else {
			moedastr = moedastr.replace(/\D/g, '');
			formRef.current?.setFieldValue(`${field}`, `${moedastr}`);
		}
	};

	async function handleSubmitLoja(form: any) {
		try {
			formRef.current?.setErrors({});

			const schema = Yup.object().shape({
				cnpj: Yup.string().required('CNPJ é obrigatório'),
				insc_estadual: Yup.string().required('Inscrição estadual é obrigatório'),
				nome: Yup.string().required('Nome da loja é obrigatório'),
				fone: Yup.string().required('Telefone é obrigatório'),
				categoria: Yup.number().required('Categoria é obrigatório'),
				descricao: Yup.string().required('Descrição da loja é obrigatório'),
				ped_min: Yup.string().required('Pedido mínimo é obrigatório'),
			});

			await schema.validate(form, { abortEarly: false });

			const { cnpj, insc_estadual, nome, fone, categoria, descricao, ped_min } = form;

			const auxPed_min = parseFloat(
				form.ped_min.replace('R$', '').replace(' ', '').replace(',', '.'),
			);

			const auxLoja: LojaDATA = {
				id: uuid(),
				cnpj,
				insc_estadual,
				nome,
				fone,
				categoria,
				descricao,
				ped_min: auxPed_min,
				endereco: {} as EnderecoDATA,
				fantazia: nome,
				url_avatar: '',
				url_page: ''
			}

			setLoja({ ...auxLoja });
			setTabEnd(false);
			handleMapAmpliar();
			setTabIndex(1);
		}
		catch (error) {
			if (error instanceof Yup.ValidationError) {
				const errors = getValidationErrors(error);
				formRef.current?.setErrors(errors);
				return;
			};
		}
		finally {
			setTimeout(() => {
				document.getElementById('endereco')?.focus();
			}, 300);
		}
	};

	// Tab ENDEREÇO
	const onMapLoad = useCallback((mapa: google.maps.Map) => {
		setMap(mapa);
	}, []);
	const onMapUnmount = useCallback(() => {
		setMap(null);
	}, []);

	const onPlacesChanged = useCallback(() => {
		if (formMapRef.current?.getFieldValue('endereco') === '') {
			return;
		}

		//const places = searchBox!.getPlaces();
		const places = searchBoxRef.current?.getPlaces();
		setPlacesAux(places);

		if (!places![0].address_components) {
			return;
		}

		formMapRef.current?.reset();

		if (places![0].address_components.length < 7) {
			setModalEndNumeroVisible(true);
			return;
		}

		if (places) {
			const place = places[0];
			const location = {
				lat: place?.geometry?.location?.lat() || 0,
				lng: place?.geometry?.location?.lng() || 0,
			};

			const aux: any[] = [];
			aux.push(location);

			setMarkers(aux);
			map?.panTo(location);

			setCenter(location);
			setZoom(17);

			if (placesAux && placesAux![0].address_components)
				formMapRef.current?.getFieldRef('comp')?.focus();
		}
	}, [map, searchBox]);
	const onDragEnd = useCallback((event: any) => {
		const places = placesAux;
		places![0].geometry.location = event.latLng;

		setPlacesAux(places);

		const markers_aux = [];
		markers_aux.push(event.latLng);

		setMarkers(markers_aux);
		map?.panTo(event.latLng);
		setCenter(event.latLng);
	},
		[placesAux, map],
	);
	const handlePlacesNum = useCallback((places: any, location: any) => {
		const location_aux = new google.maps.LatLng(location);
		places![0].geometry.location = location_aux;

		const markers_aux = [];
		markers_aux.push(location);

		setMarkers(markers_aux);
		map?.panTo(location);

		setCenter(location);
		setZoom(17);

		formMapRef.current?.reset();

		setPlacesAux(places);
	}, [map]);

	async function handleMapAmpliar() {
		setAmpliar(!ampliar);
		setMapHeight('87.2vh');
		setZoom(13);

		if (loja.endereco) {
			setCenter(loja.endereco.location);
		} else {
			setCenter({
				lat: -20.536095333200908,
				lng: -47.40091339554057,
			});
		}
	}

	async function handleSubmitEnd() {
		try {
			setLoadingContent(true);

			const end = {
				cep: placesAux![0].address_components[6].short_name,
				uf: placesAux![0].address_components[4].short_name,
				cid: placesAux![0].address_components[3].short_name,
				cidcod: '',
				bai: placesAux![0].address_components[2].short_name,
				endereco: placesAux![0].address_components[1].short_name,
				num: placesAux![0].address_components[0].short_name,
				comp: formMapRef.current?.getFieldValue('comp'),
				formatted_address: placesAux![0].formatted_address,
				location: {
					lat: placesAux![0].geometry?.location?.lat(),
					lng: placesAux![0].geometry?.location?.lng(),
				},
			};

			setEndereco({ ...end });
			setLoja({ ...loja, endereco: end });
			formMapRef.current?.reset();
			setPlacesAux(null);

			setTimeout(() => {
				setMapHeight('39.2vh');
				setCenter(end.location);
				setZoom(18);
			}, 1000);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível cadastrar endereço da loja.';

			addToast({
				type: 'error',
				title: 'Cadastro de Endereço',
				description: msg,
			});
		}
		finally {
			setTabAcesso(false);

			setTimeout(() => {
				setTabIndex(2);
				setLoadingContent(false);
			}, 300);

			setAmpliar(false);
		}
	};

	// Tab GESTÃO DE ACESSOS
	const handleAcesso = useCallback(async (access: AcessoDATA) => {
		try {
			setAcesso({ ...access }); 
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi cadastrar dados do acesso.';

			addToast({
				type: 'error',
				title: 'Dados do Acesso',
				description: msg,
			});
		}
	}, []);

	async function handleSubmit() {
		try {

			let auxLoja;

			auxLoja = loja;
			auxLoja.endereco = endereco;
			auxLoja.acessos = [ acesso ];

			const { data } = await api.post('/portal/perfil/loja', { loja });

			if (!data.emp || data.emp !== auxLoja.id)
				throw new AppError('Não foi possível cadastrar a loja');

			addToast({
				type: 'success',
				title: 'Cadastro Loja',
				description: 'Seu cadastro foi feito com sucesso, agora eh logar na conta!',
			});

			history.push('/');
		}
		catch (error) {
			console.log('ERROR ==>> ', error);

			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível cadastrar a loja.';

			addToast({
				type: 'error',
				title: 'Cadastro Loja',
				description: msg,
			});
		}
	};

  return (
		<>
			{loading ? (
				<Loading />
			) : (
				<Container>
					{loadingContent && <Loading />}

					<Content>
						<HStack w="100%">
							<Link
								variant="underline"
								color="blue.500"
								fontSize={18}
								fontWeight={500}
								mt={8}
								href="/"
							>
								<HStack>
									<MdOutlineArrowBack size={24} />
									<Text pl={2}>VOLTAR</Text>
								</HStack>
							</Link>
						</HStack>

						<TabsView>
							<Tabs className="tabs" index={tabIndex}>
								<TabList className="tab-list">
									<Tab className="tab" onClick={() => setTabIndex(0)}>
										Loja
									</Tab>
									<Tab
										className="tab"
										isDisabled={tabEnd}
										onClick={() => setTabIndex(1)}
									>
										Endereço
									</Tab>
									<Tab
										className="tab"
										isDisabled={tabAcesso}
										onClick={() => setTabIndex(2)}
									>
										Gestão de Acessos
									</Tab>
								</TabList>

								<TabPanels className="tab-panels">
									<TabLoja className="tab-panel">
										<FormView ref={formRef} onSubmit={handleSubmitLoja}>
											{/* CNPJ */}
											<div className="input">
												<p>CNPJ <span>(obrigatório)</span></p>
												<Input
													name="cnpj"
													placeholder="CNPJ"
													onChange={(e: any) => handleMaskCnpj(e.target.value)}
													onBlur={(e: any) => fetchCnpj(e.target.value)}
												/>
											</div>

											{/* INSCRIÇÃO ESTADUAL */}
											<div className="input">
												<p>Inscrição Estadual <span>(obrigatório)</span></p>
												<Input
													id="insc_estadual"
													name="insc_estadual"
													placeholder="Inscrição Estadual"
												/>
											</div>

											{/* NOME DA LOJA */}
											<div className="input">
												<p>Nome da loja <span>(obrigatório)</span></p>
												<Input
													name="nome"
													placeholder="Nome da loja"
												/>
											</div>

											{/* TELEFONE */}
											<div className="input">
												<p>Telefone de contato <span>(obrigatório)</span></p>
												<Input
													name="fone"
													placeholder="Telefone de contato"
													onChange={(e: any) => handleMaskPhone(e.target.value)}
												/>
											</div>

											{/* CATEGORIA */}
											<div className="input">
												<p>Categoria <span>(obrigatório)</span></p>
												<InputSelect
													name="categoria"
													placeholder="Categoria"
													options={categorias}
													defaultValue={''}
												/>
											</div>

											{/* DESCRIÇÃO */}
											<div className="input">
												<p>Descrição</p>
												<InputTextArea
													name="descricao"
													placeholder="Descrição"
												/>
											</div>

											{/* PEDIDO MINIMO */}
											<div className="input">
												<p>Pedido mínimo</p>
												<Input
													name="ped_min"
													placeholder="Pedido mínimo"
													defaultValue={'R$ 0,00'}
													onChange={async () => await handleMoeda('ped_min')}
												/>
											</div>

											<button>Próximo</button>
										</FormView>
									</TabLoja>

									<TabEndereco className="tab-panel">
										<MapView ampliar={ampliar}>
											{loadingMap &&
												<LoadScript
													googleMapsApiKey='AIzaSyD76z5czkAXWvXjCdvl2YaL-4QX6b4jRs4'
													libraries={libraries}
												>
													<GoogleMap
														onLoad={onMapLoad}
														onUnmount={onMapUnmount}
														mapContainerStyle={{
															width: '100%',
															height: mapHeight,
															borderRadius: '8px',
														}}
														center={center}
														zoom={zoom}
														clickableIcons={true}
													>
														<StandaloneSearchBox
															// onLoad={onLoad}
															onLoad={ref => (searchBoxRef.current = ref)}
															onPlacesChanged={onPlacesChanged}
														>
															<div className="edit-endereco">
																<h1>Alterar Endereço</h1>

																<Form ref={formMapRef} onSubmit={() => {}}>
																	<Input
																		id="endereco"
																		name="endereco"
																		placeholder="Digite um Endereço"
																	/>

																	{placesAux &&
																		placesAux![0].address_components && (
																			<div className="new-end">
																				<EndEditMap places={placesAux} />

																				<div className="input">
																					<p>Complemento</p>

																					<Input
																						name="comp"
																						placeholder="Ex. 3 andar, bloco 1, etc..."
																						containerStyle={{
																							paddingTop: '5px',
																							paddingBottom: '5px',
																						}}
																					/>
																				</div>

																				<button
																					className="btn-confirm"
																					onClick={() => {
																						// handleSubmitEnd();
																						setModalEndConfirmVisible(true);
																					}}
																					disabled={
																						placesAux![0].address_components
																							?.length < 7
																					}
																				>
																					Confirmar
																				</button>
																			</div>
																		)}
																</Form>

																<button
																	onClick={() => {
																		setAmpliar(!ampliar);
																		setZoom(18);
																		setTimeout(() => {
																			setMapHeight('39.2vh');
																		}, 1000);
																		setCenter(loja.endereco?.location);
																		formMapRef.current?.reset();
																		setPlacesAux(null);
																	}}
																>
																	Cancelar
																</button>
															</div>
														</StandaloneSearchBox>

														{!ampliar && loja.endereco?.location && (
															<Marker position={center} />
														)}

														{markers.map((marker, indice) => (
															<Marker
																key={indice}
																position={marker}
																draggable
																onDragEnd={e => onDragEnd(e)}
															/>
														))}
													</GoogleMap>
												</LoadScript>
											}
										</MapView>

										{!ampliar && (
											<div className="endereco">
												{loja.endereco ? (
													<>
														<h1>Endereço da loja</h1>
														<h2>
															{loja.endereco.endereco}, {loja.endereco.num}{' '}
															{loja.endereco.bai}
														</h2>
														{loja.endereco?.comp && (
															<h2
																style={{ color: '#546E7A', paddingTop: '0' }}
															>
																{loja.endereco.comp}
															</h2>
														)}
														<h2>CEP - {loja.endereco?.cep}</h2>
														<h2>
															{loja.endereco.cid?.toUpperCase()},{' '}
															{loja.endereco.uf?.toUpperCase()}
														</h2>
													</>
												) : (
													<h2>Loja sem endereço cadastrado.</h2>
												)}

												<button
													onClick={handleMapAmpliar}
												>
													Editar Endereço
												</button>
											</div>
										)}
									</TabEndereco>

									<GestaoAcessos className="tab-panel">
										<GestaoAcessosContent>
											<h1>Criar Acesso</h1>

											<h2>
												Crie seu acesso para logar na conta da sua loja.
											</h2>

											<GestaoAcessoForm onSubmit={() => { }}>
												{// !loja.acessos ? (
												!acesso.id ? (
													<div className="gestao-div-button">
														<button onClick={() => setModalAcessoVisible(true)}>
															Criar Acesso
														</button>
													</div>
												) : (
													<VStack w="100%">
														<Card
															variant="elevated"
															borderWidth={1}
															borderColor="gray.100"
																	w="100%"
															p={2}
														>
															<CardHeader py={1}>
																<Stack
																	direction="row"
																	justify="space-between"
																	alignItems="center"
																>
																	<Heading size='md'>
																		<MdFace />
																	</Heading>

																	<Button
																		p={1}
																		h={7}
																		bg="transparent"
																		color='blue.500'
																		_hover={{ bg: "blue.50" }}
																		onClick={() => setModalAcessoVisible(true)}
																	>
																		<FiEdit3 />&nbsp;Editar
																	</Button>
																</Stack>
															</CardHeader>

															<CardBody py={1}>
																<Stack direction='row' justify="space-between">
																	<VStack alignItems="flex-start">
																		<Text fontWeight={500}>{acesso.nome}</Text>
																		<Text fontWeight={500}>{acesso.email}</Text>
																		<Text fontWeight={500}>Administrador</Text>
																	</VStack>

																	<VStack justifyContent="flex-end">
																		<Button
																			p={1}
																			h={7}
																			bg="transparent"
																			color='red.500'
																			_hover={{ bg: "red.50" }}
																			onClick={() => {
																				setLoja({ ...loja, acessos: [] });
																			}}
																		>
																			<FiTrash2 />&nbsp;Excluir
																		</Button>
																	</VStack>
																</Stack>
															</CardBody>
														</Card>

														<HStack w="100%" justify='flex-end'>
															<Button
																bg="blue.500"
																color="white"
																rounded={8}
																px={8}
																onClick={handleSubmit}
															>
																Salvar
															</Button>
														</HStack>
													</VStack>
												)}
												
											</GestaoAcessoForm>
											{/* MOSTRAR O ACESSO CRIADO */}
										</GestaoAcessosContent>
									</GestaoAcessos>
								</TabPanels>
							</Tabs>
						</TabsView>
					</Content>					
				</Container>
			)}

			{modalEndNumeroVisible && (
				<ModalPerfilNumero
					onClose={() => setModalEndNumeroVisible(false)}
					isVisible={modalEndNumeroVisible}
					places={placesAux}
					handlePlacesNum={handlePlacesNum}
				/>
			)}

			{modalEndConfirmVisible && (
				<ModalPerfilEndConfirm
					onClose={() => setModalEndConfirmVisible(false)}
					isVisible={modalEndConfirmVisible}
					places={placesAux}
					comp={formMapRef.current?.getFieldValue('comp')}
					handleSubmitEnd={handleSubmitEnd}
				/>
			)}

			{modalAcessoVisible && (
				<ModalAcesso
					onClose={() => setModalAcessoVisible(false)}
					isVisible={modalAcessoVisible}
					acesso={loja.acessos ? loja.acessos[0] : {} as AcessoDATA}
					handleAcesso={handleAcesso}
				/>
			)}
		</>
  );
};

export default SignUp;
